import React from "react";
import { Col, FloatingLabel, Form, FormControl, Row } from "react-bootstrap";
import HoverCard from "../../shared/HoverCard";
import { SlEnergy } from "react-icons/sl";
import { TbFlame } from "react-icons/tb";
import { MdOutlineSolarPower } from "react-icons/md";
import EnergoTooltip from "../../shared/Tooltip";
import { useAuthState } from "../../../context/AuthContext";


/**
 * 
 * @param {param} data object of data passed from main container
 * @param {param} setData setter for object data
 * @param {param} errors object of errors passed from main container
 * @param {param} setErrors setter for object errors
 * 
 * @returns fields 
 */
const AnlageDataStage = ({ data, setData, errors, setErrors }) => {

    const {tooltips, tooltipsTrigger} = useAuthState();

    return (
        <>
            <Row style={errors.energyForm ? { border: "1px solid red" } : null}>
                <p>Energieform</p>
                <Col xl="4">
                    <HoverCard
                        icon={<SlEnergy size={35} />}
                        desc="Stromanlage"
                        color="energo"
                        isSelected={data.energyForm === "Strom"}
                        otherSelected={data.energyForm !== "Strom" && data.energyForm !== ''}
                        clickHandler={() => { data.energyForm === 'Strom' ? setData((prev) => ({...prev, energyForm: ""})) : setData((prev) => ({...prev, energyForm: "Strom"})); setErrors({}) }}
                    />
                </Col>
                <Col xl="4">
                    <HoverCard
                        icon={<TbFlame size={35} />}
                        desc="Gasanlage"
                        color="info"
                        isSelected={data.energyForm === "Gas"}
                        otherSelected={data.energyForm !== 'Gas' && data.energyForm !== ''}
                        clickHandler={() => { data.energyForm === 'Gas' ? setData((prev) => ({...prev, energyForm: ""})) : setData((prev) => ({...prev, energyForm: "Gas"})); setErrors({}); setData((prev) => ({...prev, smartmeter: false})) }}
                    />
                </Col>
                <Col xl="4">
                    <HoverCard
                        icon={<MdOutlineSolarPower size={35} />}
                        desc="Strom-Einspeisung"
                        color="warning"
                        isSelected={data.energyForm === "Strom-Einspeisung"}
                        otherSelected={data.energyForm !== 'Strom-Einspeisung' && data.energyForm !== ''}
                        clickHandler={() => { data.energyForm === 'Strom-Einspeisung' ? setData((prev) => ({...prev, energyForm: ""})) : setData((prev) => ({...prev, energyForm: "Strom-Einspeisung"})); setErrors({}) }}
                    />
                </Col>
            </Row>
            <Row className="align-items-center mt-5" hidden={data.energyForm === 'Gas'}>
                <Col xl="3" style={{display: "flex"}}>
                    <Form.Check type="checkbox" label="Smartmeter" checked={data.smartmeter} onChange={e => setData((prev) => ({...prev, smartmeter: e.target.checked}))} style={{marginRight: 10}} />
                    {tooltipsTrigger?
                        tooltips.find(t => t.code === 102) !== undefined?
                            <EnergoTooltip text={tooltips.find(t => t.code === 102).help_text} position="right" /> : null
                    :null}    
                </Col>
                <Col xl="3" style={{display: "flex"}}>
                    <Form.Check type="checkbox" label="Zweiter Zähler vorhanden" checked={data.secondZaehler} onChange={e => setData((prev) => ({...prev, secondZaehler: e.target.checked}))} style={{marginRight: 10}}/>
                    {tooltipsTrigger?
                        tooltips.find(t => t.code === 103) !== undefined?
                            <EnergoTooltip text={tooltips.find(t => t.code === 103).help_text} position="right" /> : null
                    :null}
                </Col>
            </Row>


            <Row className="mt-4 align-items-center">
                <Col xl="5">
                    <FloatingLabel label="Zählernummer">
                        <FormControl
                            placeholder="Zählernummer"
                            value={data.zaehlerNumber1}
                            onChange={e => {setData((prev) => ({...prev, zaehlerNumber1: e.target.value})); setErrors({})}}
                            isValid={data.zaehlerNumber1.length > 4}
                            isInvalid={errors.zaehlerNumber1}
                        />
                    </FloatingLabel>
                </Col>
                <Col xl="1" className="text-center">
                    {tooltipsTrigger?
                        tooltips.find(t => t.code === 104) !== undefined?
                            <EnergoTooltip text={tooltips.find(t => t.code === 104).help_text} position="right" /> : null
                    :null}  
                </Col>
                <Col xl="5" hidden={data.secondZaehler === undefined || data.secondZaehler === false}>
                    <FloatingLabel label="Zweite Zählernummer">
                        <FormControl
                            placeholder="Zweite Zählernummer"
                            value={data.zaehlerNumber2}
                            onChange={e => {setData((prev) => ({...prev, zaehlerNumber2: e.target.value})); setErrors({}) }}
                            isValid={data.zaehlerNumber2.length > 4}
                            isInvalid={errors.zaehlerNumber2}
                        />
                    </FloatingLabel>
                </Col>
            </Row>

            <Row className="mt-3 align-items-center">
                <Col xl="8">
                    <FloatingLabel label="Zähler-Standort">
                        <FormControl
                            placeholder="Zähler-Standort"
                            value={data.zaehlerLocation}
                            onChange={e => {setData((prev) => ({...prev, zaehlerLocation: e.target.value}))}}
                            isValid={data.zaehlerLocation != ""}
                        />
                    </FloatingLabel>
                </Col>
                <Col xl="1">
                    {tooltipsTrigger?
                        tooltips.find(t => t.code === 105) !== undefined?
                            <EnergoTooltip text={tooltips.find(t => t.code === 105).help_text} position="right" /> : null
                    :null}  
                </Col>
            </Row>
        </>
    )
}

export default AnlageDataStage;